import CouponsUserAdmin from './CouponsUserAdmin';

export default CouponsUserAdmin;
